const scrollingLists = document.querySelectorAll<HTMLElement>(
	'[data-scrolling-list]',
);

scrollingLists.forEach(wrapEl => {
	const list = wrapEl.querySelector<HTMLElement>(
		'[data-scrolling-list-element]',
	);

	if (list === null) return;

	const createButton = (
		label: string,
		className?: string,
		direction: 'left' | 'right' = 'right',
	) => {
		const button = document.createElement('button');
		button.innerText = label;
		button.className = className || '';

		const item = list.querySelector('li');
		const itemStyle = item ? getComputedStyle(item) : null;
		const gutter = itemStyle ? parseInt(itemStyle.marginRight, 10) : 0;

		button.addEventListener('click', () => {
			list.scrollTo({
				top: 0,
				left:
					list.scrollLeft + list.clientWidth * (direction == 'right' ? 1 : -1),
				behavior: 'smooth',
			});
		});

		return button;
	};

	const buttonPrev = createButton(
		window.kbStrings.prev,
		'list-section__button list-section__button--prev',
		'left',
	);
	const buttonNext = createButton(
		window.kbStrings.next,
		'list-section__button list-section__button--next',
		'right',
	);

	wrapEl.appendChild(buttonPrev);
	wrapEl.appendChild(buttonNext);

	const handleScroll = () => {
		const start = list.scrollLeft <= 0;
		const end = list.scrollLeft + list.clientWidth >= list.scrollWidth - 3;

		buttonPrev.disabled = start;
		buttonNext.disabled = end;
	};

	list.addEventListener('scroll', handleScroll);
	list.addEventListener('load', handleScroll);
	handleScroll();
});
